import styled from '@emotion/styled'

export const SearchMessageDisplayStyled = styled('div')({
  fontSize: '1.8rem',
  transform: 'translate(0%, 90%)',
  textAlign: 'center',
})
